export const css = {
	root: '_30s2h6r5',
	slideIn: '_2ceoL2TY',
	slideOut: 'KmIEpnVI',
	underlayVisible: 'wnRBSaYq',
	content: '_2lkdcE9s',
	pane: 'O3-liGCj',
	title: '_2BqJqDWC',
	titleContent: '_3FkaZawK',
	close: '_1xBygAWY',
	closeIcon: '_1xeB6dOX',
	left: '_3dQt6CRf',
	right: '_1KFnXFzc',
	top: '_24pWdkVj',
	bottom: '_387IcZml',
	open: '_11EVzM8n',
	' _key': 'base-widgets/sliding-pane'
};

export default css;
